import { UtilityService } from '../../services/utility.service';
import { Toro } from '../common/enumerations';

export class ControllerDefinition
{

    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
            this.IsControllerSupported = UtilityService.isProgrammableController(this.DeviceType);
            if(this.isLXC){
                this.IndexProgramsUsingAlphaInsteadOfNumeric = !this.isLXC;
            }
        }
    }

    public Id: number;
    public UId: string;
    public Name: string;
    public DeviceType: number;
    public NumberOfProgramsSupported: number;
    public MinNumberOfStations: number;
    public MaxNumberOfStations: number;
    public DefaultTestProgramDuration: number;
    public DefaultManualRunTimePerStation: number;
    public IndexProgramsUsingAlphaInsteadOfNumeric: boolean;
    public ProgramsHeaderText: string;
    public ProgramLabelText: string;
    public AuxiliaryHeaderText: string;
    public AuxiliaryLabelText: string;
    public StationsHeaderText: string;
    public StationLabelText: string;
    public SmartIdType: number;
    public SmartIdTypeName: string;
    public IsControllerSupported = false;

    get isEvo(): boolean
    {
        return this.Id === Toro.DeviceType.EVO;
    }

    get isLXC(): boolean
    {
        return this.Id === Toro.DeviceType.LXCEXP;
    }
}
